import cloneDeep from "lodash-es/cloneDeep"

import { createResponseTransformer } from "shared/api/createResponseTransformer"
import { serializer } from "shared/api/serializer/serializer"
import { transformJsonApiResponse } from "shared/api/transformJsonApiResponse"
import {
  FavoritesAPIType,
  ProductPositionsAPIType,
  ProjectChild,
  ProjectTypename
} from "shared/types/Project"

import { FAVORITES_PROJECT_ID } from "entities/favorites/api/useFavoriteMutations"
import { transformProductPosition } from "entities/product-positions/graphql/productPositionResponseTransformer"
import { sortProjectChildrenAndUpdateIndex } from "entities/project-children/lib/sortProjectChildren"

export const favoritesResponseTransformer = createResponseTransformer(json => {
  const deserialized = cloneDeep(
    serializer.deserialize(FavoritesAPIType, transformJsonApiResponse(json))
  )
  return { ...deserialized, type: ProjectTypename, id: FAVORITES_PROJECT_ID }
})

export const favoritesProductPositionsResponseTransformer =
  createResponseTransformer(json => {
    const deserialized = cloneDeep(
      serializer.deserialize(
        ProductPositionsAPIType,
        transformJsonApiResponse(json)
      )
    )

    if (Array.isArray(deserialized)) {
      return {
        id: FAVORITES_PROJECT_ID,
        type: ProjectTypename,
        children: sortProjectChildrenAndUpdateIndex(
          deserialized.map(transformProductPosition) as ProjectChild[]
        )
      }
    }

    return {}
  })
